var _defs, _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaLogoSquareBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1373.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#010101;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rise Art 1440px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.36,41.35H1398.63V1332.5H41.36V41.35ZM0,1373.86H1440V0H0V1373.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M524.16,623.68q0,89.34-78,112.57l94.5,131.16H463.24L377,746.06H297V867.41H236V506.47H370.3q82.62,0,118.25,27.89t35.62,89.32M443.09,674.8q18.6-16,18.6-51.38t-19.11-48.54q-19.12-13.15-68.15-13.17H297V690.81h75.91q51.62,0,70.21-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922,785.3l-36.14,82.1H820.83l159-360.92h65.07l159,360.92h-65l-36.15-82.1H922ZM1078,729l-65.59-148.72L946.82,729H1078Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 673.6,
    y: 332.65,
    width: 53.56,
    height: 708.55
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaLogoSquareBlack);
export default __webpack_public_path__ + "static/media/ra-logo-square-black.3177cf5b7586084dcca34ddc1cd3432bd54f08174359f9baef3340cd8c603fcc.svg";
export { ForwardRef as ReactComponent };